import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import { devConfig } from 'config/config'; // Importing devConfig from configuration
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the filter deposit reports view.
 * @extends JetView
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Datepicker configuration
        const fecha = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label for date
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                },
            ],
        };

        // Transaction ID input configuration
        const transactionId = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'Value',
                    type: 'number',
                    label: "<span class='icon-cash'></span>" + _('Valor Mínimo'), // Localized label for minimum value
                    labelPosition: 'top',
                    placeholder: _('Valor Mínimo'), // Localized placeholder
                },
            ],
        };

        // Minimum value input configuration
        const valueMinimum = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'ValueMinimum',
                    type: 'number',
                    label: "<span class='icon-cash'></span>" + _('Valor Mínimo'), // Localized label for minimum value
                    labelPosition: 'top',
                    placeholder: _('Valor Mínimo'), // Localized placeholder
                },
            ],
        };

        // Maximum value input configuration
        const valueMaximum = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'ValueMaximum',
                    type: 'number',
                    label: "<span class='icon-cash'></span>" + _('Valor Máximo'), // Localized label for maximum value
                    labelPosition: 'top',
                    placeholder: _('Valor Máximo'), // Localized placeholder
                },
            ],
        };

        // Upper section layout containing date and value inputs
        const upper_section = {
            cols: [fecha, valueMinimum, valueMaximum],
        };

        // Button configurations for clearing and consulting
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Localized button label for clear
                    width: 140,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Localized button label for consult
                    type: 'form',
                    width: 140,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Retrieves form values
                        this.app.callEvent('depositReportPlayer:filter', [
                            filterdata, // Calls event with filter data
                        ]);
                        $$('b5').collapse(); // Collapses the accordion section
                    },
                },
            ],
        };

        // Accordion section containing filters and buttons
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Localized header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Returns the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Retrieves current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Sets date modal based on language
        });
    }
}

// FILE DOCUMENTED
